import { Component, OnInit } from '@angular/core';
import { State } from './state';
import { StateService } from './state.service';
import { Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { UtilityService } from  '../utility.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { state } from '@angular/animations';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})
export class StateComponent implements OnInit {

  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  stateForm: FormGroup;
 
  state = new State();
  statedata : any = {}
  states: State[];
  submitted = false;
  message: string;
  totalrecord : number;
  public isupdate = false;
  public FormName = "Add State";
  
  

 stateFilter: any = { statename: '' };
public stateid : number =0;
  constructor(
    private stateService: StateService,
    private route: ActivatedRoute,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private location: Location,
    private auth: AuthService
  ) { 
    
  }

  ngOnInit(){
    this.state.active = 1;
    this.getStates();
    // const id = +this.route.snapshot.paramMap.get('id');
    // this.stateService.getState(id)
    
    this.stateForm = this.formBuilder.group({			
      statename: [this.state.statename,[Validators.required, Validators.required]],
      active: [this.state.active,[Validators.required, Validators.required]]
    });	
  }
 
// convenience getter for easy access to form fields
get f() {
  return this.stateForm.controls
  }

onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.stateForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{    
    if(this.isupdate){
 //     this.stateForm.get('statename').clearValidators();
//			this.stateForm.get('statename').updateValueAndValidity();
      this.update();
    }
    else{
      this.addState();
    }
  }
}
 addState() {
 // this.stateForm.get('statename').clearValidators();
 // this.stateForm.get('statename').updateValueAndValidity();
   this.save();
 }
 
  private save(): void {
    this.statedata = this.state;
   this.statedata.createdby = this.auth.currentUserValue.userid
    this.stateService.addState(this.statedata)
        .subscribe(() => {
			
		this.util.showSuccess("State added successfully.");
		this.getStates();
     //   this.goBack();  //for Redirecting to the list view    
     this.state = new State(); 
		});
     this.isupdate= false;
  } 


  update(): void {
    //this.submitted = true;
    this.submitted = true;
    this.statedata = this.state;
    this.statedata.modifiedby = this.auth.currentUserValue.userid;
    this.statedata.modifiedon = Date.now();
    this.stateService.updateState(this.statedata)
        .subscribe(() => 
		
		{
		this.util.showSuccess("State update successfully.");
        this.state = new State(); 
        this.isupdate= false;
        this.getStates();
		});
        this.FormName ="Add State";
  }
 
  delete(stateid): void {
    this.submitted = true;
    this.stateService.deleteState(stateid)
        .subscribe(()=> this.message = "State Deleted Successfully!");
  }
 
  goBack(): void {
    this.location.back();
  }

  getStates() {
    this.spinnerService.show();
    return this.stateService.getStates()
               .subscribe(
                 states => {                
                  this.states = states
                  this.spinnerService.hide();
				          this.totalrecord =  this.states.length;
                 }
                );
 }
 getState(stateid) {
  return this.stateService.getState(stateid)
             .subscribe(
               state => {               
                this.FormName ="Update State";
                 this.state = state;
                 this.isupdate=true;
               }
              );
}


  public onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }

  public changePagesize(num: number): void {
  this.itemsPerPage = this.pageSize + num;
  }

}
